import React from 'react';
import styles from './CartDiscount.scss';
import { CurrencyUtils } from '@wix/wixrest-utils';
import { object, string } from 'prop-types';
import { Text } from 'wix-style-react';

export default function CartDiscount({ discount, locale, currency }) {
  return (
    <div className={styles.wrapper} data-hook="cart-discount-item-wrapper">
      <div className={styles.details}>
        <Text size="medium" tagName="div" weight="normal" data-hook="cart-discount-title">
          {discount.title[locale]}
        </Text>
        <Text size="medium" tagName="div" weight="normal" secondary data-hook="cart-discount-description">
          {discount.description[locale]}
        </Text>
      </div>
      <Text size="medium" weight="normal" className={styles.price} data-hook="cart-discount-value">
        {CurrencyUtils.toStr(discount.amount / 100, currency, locale)}
      </Text>
    </div>
  );
}

CartDiscount.propTypes = {
  discount: object,
  locale: string,
  currency: string,
};
